// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__13s9O","loaderOuter":"PageOverlayLoader_loaderOuter__3pub4"};